/**
 * Everything that names this theme lives here, so it can be renamed in one place.
 *
 * - `identifier` is what the backend stores as the invite's `themeInfo.identifier`, and
 *   what previews pass as `?theme=` (e.g. /preview?theme=rang-utsav). If you change it,
 *   change it in the backend too.
 * - `name` is the human-readable name.
 * - `heroTitle` is the gold Devanagari heading at the top of the first page
 *   (the reference card's "हल्दी रस्म"); `heroTitleLabel` is what screen readers say.
 *   Not shown for a South Indian wedding (the invite's `isSouthIndian`).
 * - `gateTitle` is the welcome over the couple's names on the opening screen
 *   (scenes/GateScreen.js); `gateTitleLabel` is what screen readers say.
 *
 * The code folder (components/Utsav), the component name and the `ut-` CSS prefix are
 * internal and don't need to change when the theme is renamed.
 */
export const UTSAV_THEME = {
  identifier: "rang-utsav",
  name: "Rang Utsav",
  heroTitle: "शुभ विवाह",
  heroTitleLabel: "Shubh Vivah",
  gateTitle: "An invitation for the wedding of",
  gateTitleLabel: "An Invitation for you",
};
